import { Navigate } from "react-router-dom";
import Login from "../layouts/Login";
import Dashboard from "../layouts/Dashboard";
import Apps from "../layouts/Apps";
import AppForm from "../layouts/AppForm";
import FeatureRequests from "../layouts/FeatureRequests";
import Support from "../layouts/Support";
import Announcements from "../layouts/Announcements";
import Notifications from "../layouts/Notifications";
import Installs from "../layouts/Installs";
import Companies from "../layouts/Companies";
import Locations from "../layouts/Locations";
import Users from "../layouts/Users";
import Analytics from "../layouts/Analytics";
import ActivityLogs from "../layouts/ActivityLogs";
import AppEvents from "../layouts/AppEvents";
import Team from "../layouts/Team";
import NotFound from "../layouts/NotFound";

// "default" wraps the screen in the sidebar shell, which also enforces the
// admin session. "blank" renders the element on its own — used by the login
// screen, which paints its own full-page background.
const routes = [
  {
    key: "login",
    path: "/login",
    element: <Login />,
    layout: "blank",
  },
  {
    key: "dashboard",
    path: "/",
    element: <Dashboard />,
    layout: "default",
  },
  {
    key: "apps",
    path: "/apps",
    element: <Apps />,
    layout: "default",
  },
  {
    key: "app-new",
    path: "/apps/new",
    element: <AppForm />,
    layout: "default",
  },
  {
    key: "app-edit",
    path: "/apps/:id/edit",
    element: <AppForm />,
    layout: "default",
  },
  {
    key: "installs",
    path: "/installs",
    element: <Installs />,
    layout: "default",
  },
  {
    key: "activity",
    path: "/activity",
    element: <ActivityLogs />,
    layout: "default",
  },
  {
    key: "app-events",
    path: "/app-events",
    element: <AppEvents />,
    layout: "default",
  },
  {
    key: "team",
    path: "/team",
    element: <Team />,
    layout: "default",
  },
  {
    key: "analytics",
    path: "/analytics",
    element: <Analytics />,
    layout: "default",
  },
  {
    key: "companies",
    path: "/companies",
    element: <Companies />,
    layout: "default",
  },
  {
    key: "locations",
    path: "/locations",
    element: <Locations />,
    layout: "default",
  },
  {
    key: "users",
    path: "/users",
    element: <Users />,
    layout: "default",
  },
  {
    key: "feature-requests",
    path: "/feature-requests",
    element: <FeatureRequests />,
    layout: "default",
  },
  {
    key: "support",
    path: "/support",
    element: <Support />,
    layout: "default",
  },
  {
    key: "announcements",
    path: "/announcements",
    element: <Announcements />,
    layout: "default",
  },
  {
    key: "notifications",
    path: "/notifications",
    element: <Notifications />,
    layout: "default",
  },
  // Bare /apps/:id has nothing of its own to show.
  {
    key: "app-index",
    path: "/apps/:id",
    element: <Navigate to="edit" replace />,
    layout: "default",
  },
  {
    key: "not-found",
    path: "*",
    element: <NotFound />,
    layout: "default",
  },
];

export { routes };
